import React from 'react';
import classes from './DefaultView.module.scss';

export default ({children}) => (
  <div className={classes.defaultView}>
    {children}
  </div>
);